import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-tab1-sobre',
  templateUrl: './tab1-sobre.component.html',
  styleUrls: ['./tab1-sobre.component.css'],
  standalone: true
})
export class Tab1SobreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }



  proximo(){
    $("#tabAdesaoSeguro a").addClass('disabled');
    $('#tabAdesaoSeguro a#btnTab2').removeClass('disabled').tab('show');
  }

}
